export default function MainContent({children, ...props}) {
    return (
        <div className={`h-[calc(100vh-150px)] relative pt-[15px] ${props?.noMargin === true && 'mx-[-25px]'}`}>
            {children}
        </div>
    )
}